module.exports = __webpack_public_path__ + "media/images/the-home-depot-logo-svg-vector-26d773792865c7dc6c5bd89e930b0f05.svg";